import WebPaywalls from './web-paywalls';

export default WebPaywalls;
